<template>
  <div style="padding-top: 1em;">
    <div class="home_wrap">
      <div class="pdf-container">
        <canvas ref="pdfCanvas"></canvas>
      </div>
    </div>

    <div class="controls" >
      <button @click="prevPage" :disabled="pageNum <= 1">{{$t('cgu.previous')}}</button>
      <span> Page {{ pageNum }} of {{ numPages }} </span>
      <button @click="nextPage" :disabled="pageNum >= numPages">{{$t('cgu.next')}}</button>
    </div>

    <b-field class="controls" v-if="isActive !== null">
      <b-button @click="accepteCGA">{{$t('cgu.accepter')}}</b-button>
      <b-button @click="refuse">{{$t('cgu.refuser')}}</b-button>
    </b-field>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import pdfjsLib from 'pdfjs-dist'

export default {
  data () {
    return {
      isActive: false,
      pdf: null,
      pageNum: 1,
      numPages: 0,
      pdfUrl: '', // URL of the PDF to load
    }
  },
  computed: {
    ...mapState(['user']),
  },
  props: {
    documentUrl: String,
  },
  mounted () {
    const pdfUrl = this.documentUrl // 'https://raw.githubusercontent.com/mozilla/pdf.js/ba2edeae/examples/learning/helloworld.pdf'
    this.open(pdfUrl) // Open modal and load the PDF
  },
  methods: {
    accepteCGA () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: true
      })
    },
    refuse () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: false
      })
    },
    open (pdfUrl) {
      this.pdfUrl = pdfUrl
      this.isVisible = true
      this.loadPdf(pdfUrl)
    },
    loadPdf (url) {
      // Load the PDF document from the URL
      pdfjsLib.getDocument(url).promise.then(
        (pdfDoc_) => {
          this.pdf = pdfDoc_
          this.numPages = pdfDoc_.numPages
          this.renderPage(this.pageNum)
        },
        (error) => {
          console.error('Error loading PDF: ', error)
        }
      )
    },
    renderPage (num) {
      this.pdf.getPage(num).then((page) => {
        const canvas = this.$refs.pdfCanvas
        const context = canvas.getContext('2d')
        const viewport = page.getViewport({ scale: 1.5 }) // Adjust scale for zoom

        // Set the canvas dimensions to match the PDF page
        canvas.height = viewport.height
        canvas.width = viewport.width

        // Render the page to the canvas context
        page.render({ canvasContext: context, viewport: viewport })
      })
    },
    nextPage () {
      if (this.pageNum < this.numPages) {
        this.pageNum++
        this.renderPage(this.pageNum)
      }
    },
    prevPage () {
      if (this.pageNum > 1) {
        this.pageNum--
        this.renderPage(this.pageNum)
      }
    },
  },
}
</script>

<style scoped>
.controls{
  padding: 2px;
  max-width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
</style>
